import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Permission from "../../components/Common/Permission";
import ImageVerification from "../../components/AssetsIssuance/ImageVerification";
import OTPVerification from "../../components/AssetsIssuance/OTPVerification";
import VerifyIssuability from "../../components/AssetsIssuance/VerifyIssuability";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import { bindActionCreators } from "redux";
import * as AssetsIssuanceActions from "../../store/actions/AssetsIssuance";
import { isMobile } from "../../utils";
import { Accordion, Panel } from "sushiweb/Accordion";
import Button from "sushiweb/Button/Button";
import * as UserActions from "../../store/actions/User";

const IssuanceStatus = {
  ENV_CHECKS: 0,
  BEGIN: 1,
  PAN_VERIFIED: 2,
  IMAGE_UPLOADED: 3,
  OTP_VERIFIED: 4,
};

const ComponentIdentifier = {
  VERIFY_ENVIRONMENT: 0,
  VERIFY_ISSUABILITY: 1,
  IMAGE_VERIFICATION: 2,
  OTP_VERIFICATION: 3,
  SUCCESS: 4,
};

const AssetsIssuance = (props) => {
  const {
    partnerDetails,
    getOnboardingCenter,
    resetDriverDetails,
    resetIssuingAssets,
    setStatus,
  } = props;
  const [currentStage, setCurrentStage] = useState(IssuanceStatus.ENV_CHECKS);
  const allActions = MenuActionsMappings[MenuNames.ASSETS_ISSUANCE];
  const [envError, setEnvError] = useState("");

  const startNewIssuance = () => {
    setCurrentStage(IssuanceStatus.BEGIN);
    resetDriverDetails();
    resetIssuingAssets();
  };

  useEffect(() => {
    if (validPartner() && isMobile()) {
      setEnvError("");
      startNewIssuance();
    } else {
      if (!isMobile()) {
        setEnvError("Please use the mobile browser to Issue the assets");
      } else if (!validPartner()) {
        setEnvError("You must have an onboarding center");
      }
      setCurrentStage(IssuanceStatus.ENV_CHECKS);
    }
  }, [partnerDetails]);

  useEffect(() => {
    getOnboardingCenter();
  }, []);

  const validPartner = () => {
    if (
      partnerDetails.onboarding_center_id === "" ||
      !partnerDetails.onboarding_center_id
    ) {
      return false;
    }
    return true;
  };

  const increaseStage = (component) => {
    switch (component) {
      case ComponentIdentifier.VERIFY_ISSUABILITY:
        if (currentStage === IssuanceStatus.BEGIN) {
          setCurrentStage(IssuanceStatus.PAN_VERIFIED);
        }
        break;
      case ComponentIdentifier.IMAGE_VERIFICATION:
        if (currentStage === IssuanceStatus.PAN_VERIFIED) {
          setCurrentStage(IssuanceStatus.IMAGE_UPLOADED);
        }
        break;
      case ComponentIdentifier.OTP_VERIFICATION:
        if (currentStage === IssuanceStatus.IMAGE_UPLOADED) {
          setCurrentStage(IssuanceStatus.OTP_VERIFIED);
          setStatus({ type: "success", message: "You can Issue assets" });
        }
        break;
      case ComponentIdentifier.SUCCESS:
        setCurrentStage(IssuanceStatus.BEGIN);
        break;
      default:
        startNewIssuance();
        break;
    }
  };

  return (
    <div className="h-full w-full" id={"assetsIssuance"}>
      <Permission requiredPerms={[allActions.CREATE]}>
        {currentStage === IssuanceStatus.ENV_CHECKS ? (
          <h3 class="flex flex-col justify-center text-center"> {envError} </h3>
        ) : (
          <div
            className={
              "flex flex-col h-full w-full justify-between text-center"
            }
          >
            {currentStage === IssuanceStatus.OTP_VERIFIED && (
              <div class="col-xs-12">
                <h3>You can now deliver the assets !</h3>
                <img
                  src="/images/asset_pickup.png"
                  alt="Handover assets to driver"
                />
              </div>
            )}
            <div className={"mb-20"}>
              <Accordion id={"assetIssuanceAccordian"}>
                <Panel
                  expanded={currentStage === IssuanceStatus.BEGIN}
                  key={IssuanceStatus.BEGIN}
                  title={
                    "Step 1: " +
                    (currentStage >= IssuanceStatus.PAN_VERIFIED ? "✅" : "")
                  }
                  disabled={currentStage < IssuanceStatus.BEGIN}
                >
                  <VerifyIssuability
                    next={() =>
                      increaseStage(ComponentIdentifier.VERIFY_ISSUABILITY)
                    }
                    completed={currentStage > IssuanceStatus.BEGIN}
                    disabled={currentStage < IssuanceStatus.BEGIN}
                  />
                </Panel>
                <Panel
                  expanded={currentStage === IssuanceStatus.PAN_VERIFIED}
                  key={IssuanceStatus.PAN_VERIFIED}
                  title={
                    "Step 2: " +
                    (currentStage >= IssuanceStatus.IMAGE_UPLOADED ? "✅" : "")
                  }
                  disabled={currentStage < IssuanceStatus.PAN_VERIFIED}
                >
                  <ImageVerification
                    next={() =>
                      increaseStage(ComponentIdentifier.IMAGE_VERIFICATION)
                    }
                    completed={currentStage > IssuanceStatus.PAN_VERIFIED}
                    disabled={currentStage < IssuanceStatus.PAN_VERIFIED}
                  />
                </Panel>
                <Panel
                  expanded={currentStage === IssuanceStatus.IMAGE_UPLOADED}
                  key={IssuanceStatus.IMAGE_UPLOADED}
                  title={
                    "Step 3: " +
                    (currentStage >= IssuanceStatus.OTP_VERIFIED ? "✅" : "")
                  }
                  disabled={currentStage < IssuanceStatus.IMAGE_UPLOADED}
                >
                  <OTPVerification
                    next={() =>
                      increaseStage(ComponentIdentifier.OTP_VERIFICATION)
                    }
                    completed={currentStage > IssuanceStatus.IMAGE_UPLOADED}
                    disabled={currentStage < IssuanceStatus.IMAGE_UPLOADED}
                  />
                </Panel>
              </Accordion>
            </div>
            <div className={"flex justify-end"}>
              <Button
                size={"compressed"}
                appearance={"outline"}
                type="submit"
                onClick={startNewIssuance}
                disabled={!(currentStage >= IssuanceStatus.PAN_VERIFIED)}
              >
                {currentStage === IssuanceStatus.OTP_VERIFIED
                  ? "Start New Issuance"
                  : "Restart Issuance"}
              </Button>
            </div>
          </div>
        )}
      </Permission>
    </div>
  );
};

function mapStateToProps(state) {
  const { AssetsIssuance } = state;
  return {
    partnerDetails: AssetsIssuance.partnerDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getOnboardingCenter: bindActionCreators(
      AssetsIssuanceActions.getOnboardingCenter,
      dispatch
    ),
    resetDriverDetails: bindActionCreators(
      AssetsIssuanceActions.resetDriverDetails,
      dispatch
    ),
    resetIssuingAssets: bindActionCreators(
      AssetsIssuanceActions.resetIssuingAssets,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetsIssuance);
